import { normalize, schema } from "normalizr";
import LogService from "../services/log.service";

// import { normalize, schema, denormalize } from "normalizr";
import vuexHelpers from "../helpers/vuex.helpers";
const logEntity = new schema.Entity("logs");
const getInitialState = function () {
    return {
        entities: {},
        ids: [],
        currentId: null,
        totalItems: 0,
    };
};
const initialState = getInitialState();

const getters = {
    find: (state) => (id) => {
        return state.entities.logs[id];
    },
    current: (state, getters) => {
        return state.currentId !== null ? getters.find(state.currentId) : null;
    },
    list: (state, getters) => {
        return state.ids.map((id) => getters.find(id));
    },
};

const mutations = {
    setNormalizedData(state, normalizedData) {
        state.entities = normalizedData.entities;
        state.ids = normalizedData.result;
    },
};

const actions = {
    async table({ commit, dispatch }, data) {
        let task = await dispatch("app/addLoadingTask", "Caricamento utenti", {
            root: true,
        });

        try {
            let res = await LogService.table(data);

            if (res.isError)
                throw "Errore nel caricamento dei log";
            commit('setTotalItems', res.data.totalItems)
            commit("setNormalizedData", normalize(res.data.items, [logEntity]));
        } catch (error) {
            await dispatch(
                "app/addAlert",
                {
                    text: error,
                },
                { root: true }
            );
        }
        commit("app/removeLoadingTaskById", task.id, { root: true });
    },
}

const userModule = {
    namespaced: true,
    state: initialState,
    getters: { ...vuexHelpers.getters(initialState), ...getters },
    actions: {
        ...actions
    },
    mutations: {
        ...vuexHelpers.mutations(getInitialState),
        // ...vuexHelpers.modelMutations(formCodiceModel, "codici", {
        //   setterEntityName: "codice",
        // }),
        ...mutations,
    },
};

export default userModule;
